<!--
 * @Descripttion: 
 * @version: v1
 * @Author: Terry
 * @Date: 2020-06-04 17:18:56
 * @LastEditors: Terry
 * @LastEditTime: 2021-04-13 13:46:26
-->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>



<style lang="scss">
  *{
    margin: 0;
    padding: 0;
  }
    #app{
    width: 100vw;
    height: 100vh;
    background: url("assets/media/image/bg4.png");
    background-size:  cover;
    background-position-x: center;
  }
</style>
<script>
export default({
    name:'App',
    mounted(){
  
    }
})
</script>
